import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ClientOrderService } from '../services/client_order.service'
import { OrderClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientOrder = (locationName: string, orderId: string) => {
  return useQuery<OrderClientDto, AxiosError<{ error: string }>>({
    queryKey: ['clientOrder', locationName, orderId],
    queryFn: () => ClientOrderService.getOrder(locationName, orderId),
    ...defaultQueryOptions,
  })
}
